package br.com.vvrefeicoes.portal.domain.repository

import br.com.vvrefeicoes.portal.core.util.PeriodSelection
import br.com.vvrefeicoes.portal.domain.model.Announcement
import br.com.vvrefeicoes.portal.domain.model.AnnouncementDraft

interface AnnouncementRepository {
    suspend fun loadAnnouncements(): List<Announcement>

    suspend fun loadAnnouncementsPage(
        page: Int,
        size: Int,
        query: String = "",
        selection: PeriodSelection,
    ): AnnouncementPage = AnnouncementPage(loadAnnouncements(), totalPages = 1)

    suspend fun create(draft: AnnouncementDraft): Announcement

    suspend fun update(
        id: String,
        draft: AnnouncementDraft,
    ): Announcement

    suspend fun changeStatus(
        id: String,
        active: Boolean,
    ): Announcement

    suspend fun delete(id: String)

    /** Envia uma imagem (upload) e devolve a URL para usar como imagem do comunicado. */
    suspend fun uploadImage(
        bytes: ByteArray,
        contentType: String,
    ): String
}

data class AnnouncementPage(
    val content: List<Announcement>,
    val totalPages: Int,
)
